
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlQ as ObiOwnShipControlQElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-q.js';
 
 
 

 
 export const ObiOwnShipControlQ = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-q',
   elementClass: ObiOwnShipControlQElement,
   events: {
     
   }
  });
 
 